import routes from "@/routers/routes";
import cn from "@/utils/class-names";
import { Avatar, Button, Popover, Text, Title } from "rizzui";
// import { signOut } from "next-auth/react";
import { useContext, useEffect, useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "@/auth/authContext";
import { setSession } from "@/auth/utils";
import { permissions } from "@/app/shared/roles-permissions/permissions";

export default function ProfileMenu({
    buttonClassName,
    avatarClassName,
}: {
    buttonClassName?: string;
    avatarClassName?: string;
}) {
    const { role, username, setAuthenticated } = useContext(AuthContext);
    return (
        <ProfileMenuPopover>
            <Popover.Trigger>
                <button
                    className={cn(
                        "w-9 shrink-0 rounded-full outline-none focus-visible:ring-[1.5px] focus-visible:ring-gray-400 focus-visible:ring-offset-2 active:translate-y-px sm:w-10",
                        buttonClassName,
                    )}
                >
                    <Avatar
                        src=""
                        name={username ?? ""}
                        className={cn(
                            "!h-9 w-9 sm:!h-10 sm:!w-10",
                            avatarClassName,
                        )}
                    />
                </button>
            </Popover.Trigger>

            <Popover.Content className="z-[9999] p-0 dark:bg-gray-100 [&>svg]:dark:fill-gray-100">
                <DropdownMenu
                    setAuthenticated={setAuthenticated}
                    username={username}
                    role={role}
                />
            </Popover.Content>
        </ProfileMenuPopover>
    );
}

function ProfileMenuPopover({ children }: React.PropsWithChildren<{}>) {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname]);

    return (
        <Popover
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            shadow="sm"
            placement="bottom-end"
        >
            {children}
        </Popover>
    );
}

const menuItems = [
    {
        name: "Account Settings",
        href: routes.userManagement.users,
        auth: permissions.users.view,
    },
];

interface DropdownMenuProps {
    username: string | null;
    role: string | null;
    setAuthenticated: (value: boolean) => void;
}

function DropdownMenu({ role, username, setAuthenticated }: DropdownMenuProps) {
    const LogOut = () => {
        setSession(null);
        setAuthenticated(false);
        return <Navigate to="./login" replace={true} />;
    };
    return (
        <div className="w-64 text-left rtl:text-right">
            <div className="flex items-center border-b border-gray-300 px-6 pb-5 pt-6">
                <Avatar src="" name={username ?? ""} />
                <div className="ms-3">
                    <p className="font-semibold">{username}</p>
                    <p className="text-gray-600  text-[13px] ">
                        {username?.split("@")[0]}
                    </p>
                </div>
            </div>
            <div className="grid px-3.5 py-3.5 font-medium text-gray-700">
                {menuItems.map(
                    (item) =>
                        role?.includes(item.auth) && (
                            <Link
                                key={item.name}
                                to={item.href}
                                className="group my-0.5 flex items-center rounded-md px-2.5 py-2 hover:bg-gray-100 focus:outline-none hover:dark:bg-gray-50/50"
                            >
                                {item.name}
                            </Link>
                        ),
                )}
            </div>
            <div className="border-t border-gray-300 px-6 pb-6 pt-5">
                <Button
                    className="h-auto w-full justify-start p-0 font-medium text-gray-700 outline-none focus-within:text-gray-600 hover:text-gray-900 focus-visible:ring-0"
                    variant="text"
                    onClick={() => LogOut()}
                >
                    Sign Out
                </Button>
            </div>
        </div>
    );
}
